import React ,{ useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../Assets/WebsiteCss/aboutus.css'
import { Container,Row,Col,Card } from 'react-bootstrap'

import aboutbanner  from '../Assets/Image/Namkeenproductmain.png'
import aboutimg from '../Assets/Image/prductsupervisor.avif'

import misionimg from '../Assets/Image/mission.png';
import visionimg from '../Assets/Image/vision.png';

import { FaStar, FaBoxOpen, FaCheckCircle, FaTruck } from "react-icons/fa";
import { FaLeaf, FaCog, FaBox, FaTools } from 'react-icons/fa';

import { Helmet } from "react-helmet";

export default function AboutUs() {
  useEffect(() => {
      AOS.init({ duration: 1000, once: true });
    }, []);

    const missionVisionData = [
      {
        icon: visionimg,
        title: "Vision",
        description:
            "To become India’s most trusted and loved namkeen manufacturer, delivering traditional flavors with modern excellence.",
    },
      {
          icon: misionimg,
          title: "Mission",
          description:
              "   To craft high-quality, authentic, and delicious namkeen while ensuring the best manufacturing standards and customer satisfaction.",
      },
      
  ];
  
    const whyChooseUsData = [
      {
        icon: <FaStar className="icon text-yellow" />,
        title: "27+ Years of Experience",
        description: "Trusted by thousands for quality and taste."
      },
      {
        icon: <FaBoxOpen className="icon text-blue" />,
        title: "300+ Varieties",
        description: "From classic to innovative flavors, we have it all."
      },
      {
        icon: <FaCheckCircle className="icon text-green" />,
        title: "100% Authentic",
        description: "Handcrafted with real ingredients and traditional recipes."
      },
      {
        icon: <FaTruck className="icon text-orange" />,
        title: "Pan India Delivery",
        description: "Enjoy our delicious namkeen anywhere in India."
      }
    ];

    const expertiseData = [
      {
        title: "Raw Material Sourcing",
        icon: <FaLeaf size={30} />, // Using React Icon here
        description: "We procure the best quality ingredients for our namkeen, ensuring premium taste and authenticity in every batch.",
      },
      {
        title: "Manufacturing & Processing",
        icon: <FaCog size={30} />, // Using React Icon here
        description: "Our skilled workforce and efficient processes ensure that every namkeen product is made to perfection.",
      },
      {
        title: "Packaging & Distribution",
        icon: <FaBox size={30} />, // Using React Icon here
        description: "We ensure safe, secure, and timely packaging, maintaining freshness until our namkeen reaches you.",
      },
      {
        title: "Consultancy Services",
        icon: <FaTools size={30} />, // Using React Icon here
        description: "We assist in setting up namkeen production units and provide expert consultancy for machine installations.",
      },
    ];
  
  
  
    return (
    <>
  <div className="mainnav min-vh-100 ">
    
  <Helmet>
    <title>About Us | Narayan Salvi Namkeen – 27+ Years of Authentic Flavors & Labour Contracts</title>

    <meta
      name="description"
      content="Learn about Narayan Salvi Namkeen – Experts in namkeen manufacturing & labour contracting. 27+ years of experience, 300+ varieties, pan-India service, and complete startup guidance for your namkeen business."
    />

    <meta
      name="keywords"
      content="Namkeen Labour Contractor, Namkeen Manufacturer, Narayan Salvi, Ratlami Sev, Indore Mixture, Namkeen Machine Setup, Start Namkeen Business, Snack Recipes, Investment Plan Namkeen, Pan India Namkeen Supply"
    />

    <meta name="author" content="Narayan Salvi Group" />

    {/* Open Graph for social sharing */}
    <meta property="og:title" content="About Us | Narayan Salvi Namkeen" />
    <meta
      property="og:description"
      content="Narayan Salvi Namkeen brings 27+ years of expertise in premium namkeen manufacturing, labour contracts, and new business consultation."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/aboutus" />
    <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/static/media/Namkeenproductmain.99ab78257b303a27a3e4.png" />

    {/* Mobile responsive view */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Favicon */}
    <link rel="icon" href="/favicon.ico" />
  </Helmet>

<div className="service-container">
  <img src={aboutbanner} alt="" className="servicenamkken img-fluid" />
  <div className="service-text">"Expert Labour Contracts for Seamless Namkeen Manufacturing"</div>
</div>

<Container>
<div className="mb-2 mt-3" >
  <h2 className="middletext mb-3" data-aos="zoom-in">About Us</h2>
  <Row className='m-0'>
    <Col lg={5} className="d-flex justify-content-center" >
      <img
        src={aboutimg}
        alt=""
        style={{ height: "300px",width:'90%',objectFit:'fill', borderRadius: "8px" }}
      />
    </Col>
    <Col lg={7} >
      <p style={{ textAlign: "justify" }}>
      At <b> Narayan Salvi Group of Namkeen Labour Contractor </b>, we take pride in our 27 years of expertise in crafting premium-quality namkeen products. Founded by Narayan Salvi, a seasoned professional in the industry, we specialize in a diverse range of namkeen, including Bikaneri Moth Bhujiya, Indore Khatta Meetha Mixture, Special Ratlami Sev, Mast Kirn, Delhi Mix, Navratan Mix, Singh Bhujiya, Peanuts, Special Long Sev, Bombay Mix, Mungdaal, and over 300+ unique namkeen varieties.

Our mission is to deliver superior-quality snacks that delight taste buds across India. We have successfully completed numerous contracts, offering end-to-end solutions from manufacturing to packaging, ensuring freshness, authenticity, and excellence in every bite.

With a commitment to tradition and innovation, we continue to expand our reach, bringing authentic flavors to more people and regions. Join us on our journey as we redefine taste and quality in the world of namkeen.
      </p>
    </Col>
  </Row>
</div>

<div  className="mb-2 mt-3">
<h2 className="middletext mb-3" data-aos="zoom-in"> Vision & Mission  </h2>
<div className='missioncontainer'>
{missionVisionData.map((card, index) => (
    <Row 
        key={index} 
        className={`p-2 mt-2  justify-content-center align-items-center m-0 ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}
    >
      <Col md={6} lg={6} >
            <h3 className="text-center">{card.title}</h3>
            <p style={{ textAlign: 'justify' }}>{card.description}</p>
        </Col>
        <Col md={6} lg={6} className=" mt-2 d-flex justify-content-center">
            <img src={card.icon} alt={card.title} className="mission-vision-icon" />
        </Col>
        
    </Row>
))}
</div>
</div>

<div className="why-choose-us mt-3">
  <h2 className="middletext2 text-center" data-aos="zoom-in">Who We Are</h2>

  <Row className="justify-content-center mb-4 m-0">
    <Col lg={10} className="d-flex justify-content-center">
      <div style={{ maxWidth: "800px", textAlign: "center",textAlign:'justify'}}>
        <p>
          A company which is specialised in providing people to make understand that how to prepare the best-to-best namkeen and snacks they can get in the market.
          We also provide like which machine and all the proper investment plan to the people who just want to go for the future aspect. Our main motive is that the customer relationship must be maintained, and we serve our experience to you as your well-wisher to start your dream projects and quality products.
          We also provide the recipes to the people who are willing to learn and who are willing to set their own namkeen and snacks plant so that they can enlarge their own business or if someone wants to start a new business or wants to negotiate some ongoing business, they can also take the help from us about which is suitable new machinery for processing for your plant and in your budget, which is suitable packaging processing system according your new project file.
        </p>
      </div>
    </Col>
  </Row>
</div>


<div className=" mt-4">
      <h2 className='middletext' data-aos="zoom-in">Why Choose Us</h2>

      <Row className="  justify-center mb-4 m-0">
        {whyChooseUsData.map((item, index) => (
          <Col md={3} xs={6} sm={6} key={index} className='mb-2'>
            <Card className="choose-card">
              
              {item.icon}
              
              <h4 className='text-center'>{item.title}</h4>
              <p className='text-center' >{item.description}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
</Container>
    </div>
    </>
  )
}
